import { ChangeDetectionStrategy, Component, input } from '@angular/core';

let nextSectionId = 0;

/**
 * Card for a group of read-only facts or a secondary form inside a drawer body, with an
 * optional small uppercase heading above it. Label/value rows go in a `dl` with
 * `divide-y divide-border-muted` and `px-4 py-3` rows; pass `padded` for free content.
 */
@Component({
  selector: 'app-drawer-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-2' },
  template: `
    @if (heading()) {
      <h3 class="m-0 px-1 text-xs font-extrabold uppercase tracking-eyebrow text-text-muted" [id]="headingId">
        {{ heading() }}
      </h3>
    }
    <section
      class="overflow-hidden rounded-lg border border-border bg-surface-elevated"
      [class.p-4]="padded()"
      [attr.aria-labelledby]="heading() ? headingId : null"
    >
      <ng-content />
    </section>
  `,
})
export class DrawerSectionComponent {
  readonly heading = input<string | undefined>();
  readonly padded = input(false);

  protected readonly headingId = `app-drawer-section-${nextSectionId++}`;
}
